// @ts-nocheck
import ActionTypes from "../constants/actions";
import { Map, Record, Set } from "immutable";
import { mergeArraytoSet, addToSet, updateSet } from "../utils/redux";
import _ from "lodash";

const Settings = Record({
  _id: "",
  uploads: []
});

export const defaultState = { loading: false, error: "", result: new Set() };
export default ({ result } = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.SET_ALL_UPLOADS:
      console.log("action setting: ", action.setting, result);
      const functionToUse = result.size ? updateSet : addToSet;
      return { loading: false, error: "", result: functionToUse(action.setting, result, Settings) };
      break;
    default:
      return { loading: false, error: "", result };
  }
};
